import React from 'react';
import { FormattedMessage } from 'react-intl';

export const ITEMS_PER_PAGE = 20;
export const MAX_ALERT_COUNT = 40;

export const DS = {
  CONSUMER: {
    LI: 'loggedin.web.jobs.search_results.center',
    LO: 'loggedout.web.jobs.search_results.center',
  },
  SERVICE: {
    SEARCH: 'ds.search.jobs',
    RECOMMENDATIONS: 'ds.recommendations.jobs',
  },
} as const;

export const MIN_SALARY = 0;
export const MAX_SALARY = 200_000;
export const STEP_SALARY = 1_000;

export const DEFAULT_SORT = 'relevance';
export const SORT_OPTIONS = {
  relevance: <FormattedMessage id="SE_SORT_JOBS_RELEVANCE_LABEL" />,
  date: <FormattedMessage id="SE_SORT_JOBS_DATE_LABEL" />,
  rating: <FormattedMessage id="SE_SORT_JOBS_RATING_LABEL" />,
};

export const DEFAULT_RADIUS = 20;
export const RADIUS_OPTIONS = [0, 10, 20, 50, 70, 100, 200];
